export default function formatPrice(priceInCents: number) {
    const formattedPrice = (priceInCents / 100).toLocaleString("en-US", {
        minimumFractionDigits: 2,
    });

    return `$${formattedPrice}`;
}
